import { endpoints } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Auth } from '../../autentication/Auth';
import { map } from 'rxjs/operators/map';
import { Card } from './model/card';

@Injectable()
export class CardsService {

  cards: Array<Card>;

  constructor(private http: HttpClient) { }

  changePassword(changePassData: any): Observable<any> {
    const dataResetPassword = {
      NrDigCartao: changePassData.num,
      NovaSenha: changePassData.pass
    };

    return this.http.post(endpoints.cards.updatePassword, dataResetPassword);

  }

  getCards(numCard: string): Observable<Card[]> {
    return this.http.get(endpoints.cards.list + '?nrDigCartao=' + numCard).pipe(map((data: any) => {

      if (data.Sucesso) {

        if (data.Retorno !== undefined) {
          this.cards = data.Retorno.cartoes.map(item => {
            const card = new Card();

            card.num = item.nrCartao;
            card.numLabel = 'xxxx xxxx xxxx ' + item.nrCartao;
            card.state = item.codEstado;
            card.image = data.Retorno.imgCartao;

            return card;
          });
        }
      }

      return this.cards;

    }));
  }

  confirmUnlockOrBlockCard(card: Card): Observable<any> {

    if (card.state == 17) {
      const cardData: any = {
        "NrCartao": card.num
      };

      return this.http.post(endpoints.cards.unlockCard, cardData).pipe(map((data: any) => {
        return data;
      }));
    } else {
      const cardData: any = {
        "NrDigCartao": card.num,
        "FlagBloqueio": card.state == 11 ? false : true
      };

      return this.http.post(endpoints.cards.blockCard, cardData).pipe(map((data: any) => {
        return data;
      }));
    }

  }

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/cards/cards.service.ts